export const AboutImgs = {
	about1: 'https://web-data.zmlearn.com/image/nKjLA5gyJ4SvQYsWpTPqBL/about_1@2x.png',
	about2: 'https://web-data.zmlearn.com/image/77TGQonsDs9JvDv521LUiS/about_2@2x.png',
	about3: 'https://web-data.zmlearn.com/image/b4fv5pgXtUjUTYDSvW1gzw/about_3@2x.png',
	about4: 'https://web-data.zmlearn.com/image/dvqrpzYGeo1SCUq8qGJjBR/about_4@2x.png',
	about5: 'https://web-data.zmlearn.com/image/9vCL4KyYPmYecz9S7RXdqV/about_5@2x.png',
	about6: 'https://web-data.zmlearn.com/image/ko1WiyGCW4B6h1mkpiNcwG/about_6@2x.png',
	about7: 'https://web-data.zmlearn.com/image/gc8T6NsC9DYdbTuKhw9TgA/about_7@2x.png',
};

export const BottomIcons = {
	bottom1: 'https://web-data.zmlearn.com/image/6CRYK5PEp3T1AUkjvyGfVc/bottom_1@2x.png',
	bottom2: 'https://web-data.zmlearn.com/image/8YqFzs5jAtzNwPd9dFxs8s/bottom_2@2x.png',
	bottom3: 'https://web-data.zmlearn.com/image/jceFLtuhrpaJedWQ635gi5/bottom_3@2x.png',
	bottom4: 'https://web-data.zmlearn.com/image/sbbsgCVtgcXSWuBv6CEVgE/bottom_4@2x.png',
	bottom5: 'https://web-data.zmlearn.com/image/45RcfiPhcaNczvCXN1dagX/bottom_5@2x.png',
};

export const SubjectImgs = {
	subject1: 'https://web-data.zmlearn.com/image/3uoqaeEoCiXeJBu75VBDB2/subjects_1@2x.png',
	subject2: 'https://web-data.zmlearn.com/image/h13fpMk5EuP5hgPWQwC2AA/subjects_2@2x.png',
	subject3: 'https://web-data.zmlearn.com/image/woNGo9xfZKQsdodszwYsG1/subjects_3@2x.png',
};

export const PlatformIcons = {
	platformIcon2: 'https://web-data.zmlearn.com/image/76wHBuhXhR1Bw1MxgpXKqM/platform_icon_2@2x.png',
	platformIcon1: 'https://web-data.zmlearn.com/image/cSXrX1PUMqBpMRM929Y2Jj/platform_icon_1@2x.png',
	platformIcon3: 'https://web-data.zmlearn.com/image/joJuvSv2cRkLbrXkUcXjZX/platform_icon_3@2x.png',
};

export const PlanIcons = {
	planStep: 'https://web-data.zmlearn.com/image/m95qt5puMuCGzuXgmUrTWd/plan_step@2x.png',
	planIcon3: 'https://web-data.zmlearn.com/image/g5ms9owQvgMSRTKK2e7hcD/plan_icon_3@2x.png',
	planIcon1: 'https://web-data.zmlearn.com/image/pguXt3aqUXRkD8RQMA97cx/plan_icon_1@2x.png',
	planIcon4: 'https://web-data.zmlearn.com/image/4JHh94vdbhxRsRe9szzACW/plan_icon_4@2x.png',
	planIcon2: 'https://web-data.zmlearn.com/image/fpsKCj1hJZk1WxgrDEBBwv/plan_icon_2@2x.png',
};

export const ConvenientImgs = {
	convenient1: 'https://web-data.zmlearn.com/image/2n8KXDM3aZ4Z3ePtj8sTjW/convenient_1@2x.png',
	convenient2: 'https://web-data.zmlearn.com/image/9tN8x1EEtSLxv3WCBys8Eo/convenient_2@2x.png',
	convenient3: 'https://web-data.zmlearn.com/image/sfRcBmv3Mbci4YkJXHGF85/convenient_3@2x.png',
};

export const TutorsLabelIcons = {
	iconUniversities: 'https://web-data.zmlearn.com/image/94yjDnkzG2ne76V6iRwvU3/icon_universities@2x.png',
	iconTutors: 'https://web-data.zmlearn.com/image/s2Ce6ZbgruKP9uF4uSzYr2/icon_tutors@2x.png',
	iconTutorPassRate: 'https://web-data.zmlearn.com/image/9xxaqgDKgxrqVoUE8nC5MB/icon_tutor_pass_rate@2x.png',
};
export const TutorsAvatars = {
	tutors4: 'https://web-data.zmlearn.com/image/v5Z2pT6ZNEaKY3zWzeqS9H/tutors_4@2x.png',
	tutors5: 'https://web-data.zmlearn.com/image/osStq95of7HZ886fVDp7E8/tutors_5@2x.png',
	tutors6: 'https://web-data.zmlearn.com/image/rK3vRWJW8V5SZmFddVNPRG/tutors_6@2x.png',
};
export const BgImgs = {
	bg1: 'https://web-data.zmlearn.com/image/dpNGYP4o2nhk7kLhJytMQ3/bg_1@2x.png',
	bg2: 'https://web-data.zmlearn.com/image/tDvXUU1Lo3KaAJKFM76FYh/bg_2@2x.png',
	bg3: 'https://web-data.zmlearn.com/image/2UkGqb9biGoS87D6cAmhMS/bg_3@2x.png',
	bg4: 'https://web-data.zmlearn.com/image/a4wWaWgXwR3EabyP2hJqZx/bg_4@2x.png',
	bg5: 'https://web-data.zmlearn.com/image/dVgqSXhx5W93BPFeW5CbqP/bg_5@2x.png',
	bg6: 'https://web-data.zmlearn.com/image/orx6BtzYgbrS1wNLaRkrxS/bg_6@2x.png',
	line: 'https://web-data.zmlearn.com/image/vdueJrNxR8GAazRFE2CTn7/line%402x.png',
};
export const BannerImg = 'https://web-data.zmlearn.com/image/kpKJJ1MKXqiE4WoQhUaiuf/banner%402x.png';
export const BannerTitle = 'https://web-data.zmlearn.com/image/wxviVotT8nCuX5N689yCfs/%E6%A0%87%E9%A2%98%402x%20(1).png';
export const PlatformImg = 'https://web-data.zmlearn.com/image/r6H7dxYbpaAu8RyRbDZfNN/platform_1%402x.png';
export const StarIcon = 'https://web-data.zmlearn.com/image/wK8FgWcAtegqvpw3oz9UR5/star%402x.png';
export const PeopleImgs = {
	people1: 'https://web-data.zmlearn.com/image/2sZJqdjCWcJ41tgFcJZuC7/people%402x.png',
	people2: '',
};
